import React, {useState, useEffect} from 'react'
import '../../../Work-css/Scholarship.css';
import Fill_IYP from './Fill_IYP'
import Front_ID from '../Upload_images/Front_ID'
import Back_ID  from '../Upload_images/Back_ID'
import Passport_pic from '../Upload_images/Passport_pic'
import Multiple_images from './Multiple_images'
 
function Scholarship_intro({setScholarship}) {
    const [spa_fill, setSpa_fill] = useState(false)
    const [front_ID, setFront_ID] = useState(false)
    const [back_ID, setBack_ID] = useState(false)
    const [passport, setPassort] = useState(false)
    const [scholarship_part, setScholarship_part] = useState(true)

    const [name, setName] = useState('')
    const [school_level, setSchool_level] = useState('')
    const [parent_phone, setParent_phone] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [altphone, setAltphone] = useState('')
    const [date, setDate] = useState('')
    const [about_you, setAbout_you] = useState('')
    
    const [timestamp, setTimestamp] = useState("");

     useEffect(() => {
        setTimestamp(getCurrentDateTime());
     }, []);

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };
    const collection = {
        spa_fill,
        front_ID,
        back_ID,
        passport,
        timestamp,

        name,
        school_level,
        parent_phone,
        email,
        phone,
        altphone,
        date,
        about_you,

        setName,
        setSchool_level,
        setParent_phone,
        setEmail,
        setPhone,
        setAltphone,
        setDate,
        setAbout_you,

        setSpa_fill,
        setFront_ID,
        setBack_ID,
        setPassort,
        setScholarship,
    }

    const decline = () =>{
      setScholarship(false)
    }

    const accept = () =>{
      setSpa_fill(true)
      setScholarship_part(false)
    }
  return (
    <div className={'scholarship_terms'}>
      {scholarship_part?(<div>

               <p className={'welcome_to_p'}>Welocme to IFY Scholarship application</p>

        <div className={'t_ctext'}>

          By applying for our Scholarship, you agree to be bound by these Terms and Conditions. 
      You are responsible for maintaining the confidentiality of your account 1  credentials and using the 
      Portal only for legitimate educational purposes. The school reserves the right to suspend or terminate 
      your account for unauthorized access or misuse. Your personal information will be handled in accordance 
      with applicable data protection laws. The school may modify these Terms and Conditions at any time, and 
      any changes will be effective immediately upon posting on the Portal. 
     
            
        </div>

        <div className={'IFY_BUTTON_FLEX'}>
            <div onClick={accept} className='submit'>Accept</div>
            <div onClick={decline} className='submit'>Decline</div>
        </div>

      </div>):('')}
 

        {spa_fill?(<div className="SP_BG"><div className = 'Fill_fyp_scroll'><Fill_IYP collection={collection} /></div></div>):('')}
        {front_ID?(<div className="SP_BG"><div className = 'Fill_fyp_scroll'><Multiple_images collection={collection}/></div></div>):('')}
        {back_ID?(<div className="SP_BG"><div className = 'Fill_fyp_scroll'><Back_ID collection={collection}/></div></div>):('')}
        {passport?(<div className="SP_BG"><div className = 'Fill_fyp_scroll'><Passport_pic collection={collection}/></div></div>):('')}
      
    </div>
  )
}

export default Scholarship_intro
